import script from "./diamondsDiamondDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./diamondsDiamondDetails.vue?vue&type=script&setup=true&lang=ts"

import "./diamondsDiamondDetails.vue?vue&type=style&index=0&id=7e56bf82&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e56bf82"]])

export default __exports__